import React from "react";
import { LandingPageShell } from "../Components/Landing/LandingSystem";
import { WebsitePromotionPageBannerSlot } from "../Components/Promotions/WebsitePromotionPageBanner";

// The header, booking entry and campaign can paint independently of listing
// projections, saved items, story viewers and the destination catalogue.
export function HomeLandingFrame({ children, explore = false }) {
  return (
    <LandingPageShell className={`ecotour-home-frame ${explore ? "pb-20" : "pb-6 sm:pb-8"}`}>
      {!explore && <div id="home-quick-book-entry" className="quick-book-home-slot" data-enabled={process.env.REACT_APP_QUICK_BOOK_V1 === "true" ? "true" : undefined} />}
      <div id="home-promotion-banner">
        <WebsitePromotionPageBannerSlot alignWithPageContent className="px-3 pt-2 sm:px-6 sm:pt-4 lg:px-8" />
      </div>
      {children}
    </LandingPageShell>
  );
}
